import { isNullOrUndefOrEmpty } from 'utils';

export default function isObject(value) {
  return !isNullOrUndefOrEmpty(value) && (typeof value === 'object' || value instanceof Object);
}
